export const KPI_MANAGEMENT = [
  {
    id: 1,
    title: "Tổng số KPI thưởng",
    content: "VNĐ",
    nameIcon: "bx bx-message-check",
    // number: 2000000,
  },
  {
    id: 2,
    title: "Tổng doanh thu",
    content: "VNĐ",
    nameIcon: "bx bx-message-rounded-minus",
    // number: 2000000,
  },
  {
    id: 3,
    title: "Tổng hoa hồng",
    content: "VNĐ",
    nameIcon: "bx bx-message-rounded-minus",
    // number: 2000000,
  },
  {
    id: 4,
    title: "Tổng HĐ",
    content: "Hợp đồng",
    nameIcon: "bx bx-area",
    // number: 1000,
  },
];

export const LIST_ITEM = [
  {
    id: 1,
    title: "Hợp đồng đầu tư hôm nay",
    content: "Hợp Đồng",
    nameIcon: "bx bx-message-check",
    number: 100,
  },
  {
    id: 2,
    title: "Tổng số hợp đồng",
    content: "Hợp đồng",
    nameIcon: "bx bx-message-rounded-minus",
    number: 10000,
  },
  {
    id: 3,
    title: "Tổng số nhân viên",
    content: "Nhân viên",
    nameIcon: "bx bx-area",
    number: 3000,
  },
  {
    id: 4,
    title: "Khách hàng mới trong tháng",
    content: "Khách hàng",
    nameIcon: "bx bx-group",
    number: 1000,
  },
];
export const DATA_CURRENT = [
  {
    title: "Hợp đồng gần đây",
    modelName: "Contract",
    orderField: "createdAt",
    limit: 4,
  },
];
export const DATA_CHART = [
  {
    titleOfLine:
      "Tổng số lượng khách hàng truy cập thông qua các nền tảng quảng cáo ",
    titleOfBar: "Tổng doanh thu hôm nay",
    titleOfDoughnut: "Doanh thu tháng 2",
    data: [
      {
        branch: "Chi Nhánh 1",
        turnover: 1000000,
      },
      {
        branch: "Chi Nhánh 2",
        turnover: 2000000,
      },
      {
        branch: "Chi Nhánh 3",
        turnover: 3000000,
      },
      {
        branch: "Chi Nhánh 4",
        turnover: 4000000,
      },
    ],
  },
];

export const DATA_CUSTOMER_REPORT = [
  {
    title: "Báo cáo thống kê nguồn khách hàng qua các nền tảng",
    data: [
      {
        customerId: "#001",
        customerName: "Nguyễn Văn A",
        customerResources: "Youtube",
      },
      {
        customerId: "#002",
        customerName: "Nguyễn Văn B",
        customerResources: "Youtube",
      },
      {
        customerId: "#003",
        customerName: "Nguyễn Văn C",
        customerResources: "Youtube",
      },
      {
        customerId: "#004",
        customerName: "Nguyễn Văn D",
        customerResources: "Youtube",
      },
    ],
  },
];

export const DATA_AGENCY_CHART = [
  {
    title: "Tổng doanh thu theo đại lý",
    data: [
      {
        agency: "Đại lý 1",
        quantity: 1,
      },
      {
        agency: "Đại lý 2",
        quantity: 2,
      },
      {
        agency: "Đại lý 3",
        quantity: 3,
      },
      {
        agency: "Đại lý 4",
        quantity: 4,
      },
    ],
  },
];
